import React, { Component } from 'react';
import '../../../common/index.scss';
import Skeleton from 'react-loading-skeleton';

const smallImage = [1, 2, 3, 4];
class ProductListingLoader extends Component {

    render() {
        return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                        {/* <div className="loading-cls"></div> */}
                        <div className="row">
                                    {smallImage.map((product, index) =>
                                        <div className='col-md-6 col-grid-box' key={index} style={{marginTop: 35}}>
                                            <Skeleton width="100%" height={300} />
                                            <Skeleton width="75%" height={20} style={{marginTop: 8}}/>
                                            <Skeleton width="30%" height={20} style={{marginTop: 8}}/>
                                            <ul style={{marginTop: 8}}>
                                                {smallImage.map((dum, i) => {
                                                    return <li key={i} style={{marginRight: 5}}>
                                                        <Skeleton circle={true} height={20} width={20}/>
                                                    </li>
                                                })}
                                        </ul> 
                                        </div>)
                                    }
                                </div>
                        </div>
                    </div>
                </div>
        )
    }
}


export default ProductListingLoader;